import { CSSProperties, ReactNode } from 'react';
import Image from 'next/image';
import cn from 'classnames';

import CloseIcon from 'public/img/icon/close.svg';

import './BaseModal.style.scss';

export type BaseModalProps = /* ModalProps & */ {
  className?: string;
  children: ReactNode;
  onClose: () => void;
};

function BaseModal(props: BaseModalProps) {
  const { className = '', children, onClose } = props;

  return (
    <div className={cn('BaseModal', className)}>
      <div className='BaseModal-content'>
        <div className='BaseModal-header'>
          <Image
            className='BaseModal-close-icon cursor'
            alt='Close modal icon'
            src={CloseIcon}
            height={20}
            width={20}
            onClick={onClose}
          />
        </div>
        {children}
      </div>
    </div>
  );
}

export default BaseModal;
